import React from "react";

import styles from "./Section.module.css"
import classnames from "classnames";

interface SectionProps {
    title: string
    children: any
    backgroundColor?: string
    actions?: React.ReactNode
    fillHeight?: boolean
}


export const Section: React.FC<SectionProps> = ({title, children, backgroundColor, actions, fillHeight}) => {

    return <div className={classnames(styles.wrapper, fillHeight && styles.fillHeight)} style={{backgroundColor: backgroundColor}}>
        {actions ? <div className={styles.header}>
            <h4 className={styles.headerTitle}>{title}</h4>
            <div className={styles.actions}>{actions}</div>
        </div> : <h4 className={styles.title}>{title}</h4>}
        <div className={styles.fieldsWrapper}>{children}</div>
    </div>
}
